<template>
  <v-tooltip v-if="show" left>
    <template #activator="{ on }">
      <v-icon small v-on="on">{{ icon }}</v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NotesListNoteVisibility',

  props: {
    note: {
      type: Object,
      required: true
    },

    forceShow: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),

    icon() {
      return this.note.private
        ? '$freshvuenotes-visibility-private'
        : '$freshvuenotes-visibility-public'
    },

    text() {
      return this.note.private
        ? this.$t('fresh-vue-notes.visibility.private-text')
        : this.$t('fresh-vue-notes.visibility.public-text')
    },

    show() {
      return this.forceShow || this.user?.user_id == this.note?.created_by?.id
    }
  }
}
</script>
